import type { DecisionReport, Locale } from "../shared/types";

const DRAFT_KEY = "dingjian:draft:v1";

export interface LocalDraft {
  step: "start" | "clarify" | "report";
  decision: string;
  questions: string[];
  answers: string[];
  locale: Locale;
  coachIntro?: string;
  report?: DecisionReport;
}

export function saveDraft(draft: LocalDraft): void {
  localStorage.setItem(DRAFT_KEY, JSON.stringify(draft));
}

export function loadDraft(): LocalDraft | null {
  try {
    const raw = localStorage.getItem(DRAFT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<LocalDraft>;
    if (
      !["start", "clarify", "report"].includes(parsed.step ?? "") ||
      typeof parsed.decision !== "string" ||
      !Array.isArray(parsed.questions) ||
      !Array.isArray(parsed.answers) ||
      !["zh-TW", "zh-CN"].includes(parsed.locale ?? "")
    ) return null;
    return parsed as LocalDraft;
  } catch {
    return null;
  }
}

export function clearDraft(): void {
  localStorage.removeItem(DRAFT_KEY);
}
